export interface FetchNotificationParam {
  responseStatus: string[];
}

export type ApiResponse = Record<string, any>;

export interface Notification extends ApiResponse {
  newRecordInsuranceTypes: number[];
}

export enum NotificationActionTypes {
  FETCH_REQUEST = '@@notification/FETCH_REQUEST',
  FETCH_SUCCESS = '@@notification/FETCH_SUCCESS',
  FETCH_ERROR = '@@notification/FETCH_ERROR',
}

export interface FetchRequestAction {
  type: NotificationActionTypes.FETCH_REQUEST;
}

export interface FetchSuccessAction {
  type: NotificationActionTypes.FETCH_SUCCESS;
  payload: Notification;
}

export interface FetchErrorAction {
  type: NotificationActionTypes.FETCH_ERROR;
  payload: { status: number; data: string };
}

export type NotificationActions =
  | FetchRequestAction
  | FetchSuccessAction
  | FetchErrorAction;

export interface NotificationState {
  data: Notification;
  loading: boolean;
  errors?: { status: number; data: string };
}
